module.exports = __webpack_public_path__ + "static/img/04-人大附中通州校区.47146bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/04-人大附中通州校区.png
// module id = 80UF
// module chunks = 0